import { render } from "./FinancialSupports.vue?vue&type=template&id=16681f3a"
import script from "./FinancialSupports.vue?vue&type=script&lang=js"
export * from "./FinancialSupports.vue?vue&type=script&lang=js"

import "./FinancialSupports.vue?vue&type=style&index=0&id=16681f3a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__